import React from "react";
import { RendezVousTemplate } from "../../components/templates";

function RendezVous() {
  return <RendezVousTemplate />;
}

export default RendezVous;
